<div class="mw-profile-menu">
  <div class="mw-profile-menu__header">
    <div class="mw-profile-menu__header-user-info">
      <div class="mw-profile-menu__header-user-info-initials">
        {{ service.nameInitials }}
      </div>
      <div>
        <div class="text-subtitle-2">{{ service.userFullName }}</div>
        <div class="text-caption">{{ service.companyName }}</div>
      </div>
    </div>
    <div class="mw-profile-menu__header-actions">
      <button mat-icon-button (click)="onCloseMenu()" class="mw-icon-button-24">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="mw-profile-menu__content" mwPerfectScrollBar>
    <mat-nav-list>
      <mat-list-item
        *ngFor="let item of service.profileMenuItems"
        (click)="onClick(item)"
      >
        <mat-icon
          class="mw-icon-20"
          *ngIf="item.svgIcon"
          [svgIcon]="item.svgIcon"
        ></mat-icon>
        <mat-icon
          class="mw-icon-20"
          fontSet="material-symbols-outlined"
          *ngIf="item.icon"
        >
          {{ item.icon }}
        </mat-icon>
        {{ item.title | translate }}
      </mat-list-item>
    </mat-nav-list>
  </div>
  <mat-divider></mat-divider>
  <div class="mw-profile-menu__footer">
    {{ 'CORE.AUTH.PAGE.LOGIN.version' | translate }}: {{ version }}
  </div>
</div>
